import router from './router'


import {getToken} from '@/auth' // 验权
import Cookies from 'js-cookie'
const whiteList = ['/login','/register'] // 不重定向白名单



function recursive (arr, id){

    var name = false
    function fn(arr, id) {
        var flag = false
        for (var i in arr) {
            if (arr[i].path == id) {
                name = true
                flag = true
            }
        }

        if (!flag) {
            for (var j in arr) {
                fn(arr[j].children, id)
            }
        }
    }

    fn(arr, id)
    return name
}



router.beforeEach((to, from, next) => {
    let token = getToken()
    console.log(token)
    console.log(to)
    if (getToken() != 'Basic enV1bDp6dXVs') {
        if (to.path === '/login') {
            next({path: '/'})
        }else{
            next()
        }
        // if (store.getters.roles === null) {
    //     store.dispatch('GetUserPermissionsInfo').then(res => { // 拉取用户信息
    //
    //     })
    //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
    //     localStorage.setItem('sellerId', res.data.id)
    //     Cookies.set('sellerId', res.data.id)
    //     // next()
    //     if (to.path === '/login' && to.fullPath.indexOf('redirect') < 0) {
    //       next({path: '/'})
    //
    //     } else if (to.path === '/login' && to.fullPath.indexOf('redirect') > 0) {
    //       var redirect = decodeURIComponent(to.fullPath.split('=')[1])
    //       next(`${redirect}`)
    //
    //     } else {
    //       next()
    //     }
    //     console.log(res)
    //   }).catch((err) => {
    //     store.dispatch('FedLogOut').then(() => {
    //       // Message.error(err || 'Verification failed, please login again')
    //       console.log(err)
    //       // next({ path: '/' })
    //       if (to.path === '/login' && to.fullPath.indexOf('redirect') < 0) {
    //         next({path: '/'})
    //
    //       } else if (to.path === '/login' && to.fullPath.indexOf('redirect') > 0) {
    //         var redirect = decodeURIComponent(to.fullPath.split('=')[1])
    //         next(`${redirect}`)
    //
    //       } else {
    //         next()
    //       }
    //     })
    //   })
    // } else {
    //   if (to.path === '/login' && to.fullPath.indexOf('redirect') < 0) {
    //     next({path: '/'})
    //
    //   } else if (to.path === '/login' && to.fullPath.indexOf('redirect') > 0) {
    //     var redirect = decodeURIComponent(to.fullPath.split('=')[1])
    //     next(`${redirect}`)
    //
    //   } else {
    //     next()
    //   }
    // }
    } else {
    // next()
        if ( whiteList.indexOf(to.path) !== -1 || to.path === '/download') {
            next()
        } else {
            next(`/login`) // 否则全部重定向到登录页    ?redirect=${to.path}   为记录退出前的页面路由
        }
    }
})
